import { CircuitRoomingListExportCriteria } from "../objects/circuitRoomingListExportCriteria";
import { RoominglistHistoryCriteria } from "../objects/roomingListHistory";

export const EMPTY_CIRCUIT_ROOMING_LIST_EXPORT_CRITERIA: CircuitRoomingListExportCriteria = {
    circuit: null,
    provider: null,
    start_date: null,
    end_date: null,
    destination: null
};

export const EMPTY_ROOMING_LIST_HISOTRY_CRITERIA: RoominglistHistoryCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
};